<template>
  <div>
    <v-os-popup
      class="address-new-popup popups-pb"
      :class="{ 'custom-dark': customDark }"
      v-model="selectShow"
      :title="isPickUp ? '选择取件地址' : '选择收货地址'"
      :closeShow="true"
      :footerShow="false"
      @close="closeSelector"
    >
      <AddressSelect
        ref="addressSelectRef"
        :addresses="addresses"
        :addressId="addressId"
        :isPickUp="isPickUp"
        :disabledDel="disabledDel"
        :disabledEdit="disabledEdit"
        @goToNewAddress="goToNewAddress"
        @close="closeSelector"
        @change="change"
        @clear="clear"
      />
      <template v-slot:footer>
        <div class="custom-footer" @click="goToNewAddress">
          <v-button type="frame-plus" position="center">
            <v-icon name="icon-ads-plus"></v-icon>
            <span>{{ isPickUp ? '添加取件地址' : '添加收货地址' }}</span>
          </v-button>
        </div>
      </template>
    </v-os-popup>
    <v-os-popup
      class="address-new-popup popups-no-pb popups-is-form"
      :class="{ 'custom-dark': customDark }"
      v-model="addressShow"
      :title="isEdit ? (isPickUp ? '修改取件地址' : '修改收货地址') : isPickUp ? '新增取件地址' : '新增收货地址'"
      footer-text="保存并使用"
      :closeShow="true"
      :footerShow="true"
      :maxHeightFill="true"
      @close="closeEditAdress"
      @footerClick="saveAddressData"
    >
      <div class="address-form">
        <div class="address-form-body">
          <div class="item name">
            <nx-input-item
              :title="isPickUp ? '姓名' : '收货人'"
              :class="{ 'linkman-padding': isVivoApp }"
              v-model="addressInfo.receiverName"
              :placeholder="isPickUp ? '请填写姓名' : '请填写收货人姓名'"
            >
              <template v-slot:right v-if="isVivoApp">
                <span class="linkman" @click="selectContact">
                  <i class="icon-linkman"></i>
                  <span class="text">通讯录</span>
                </span>
              </template>
            </nx-input-item>
          </div>
          <div class="item phone">
            <nx-input-item
              title="手机号码"
              v-model="addressInfo.mobilePhone"
              type="phone"
              :placeholder="isPickUp ? '请填写手机号码' : '请填写收货人手机号码'"
            ></nx-input-item>
          </div>
          <div class="item area" @click="goSelector">
            <nx-input-item
              title="所在地区"
              type="text"
              multiline
              :maxRows="1"
              v-model="area"
              placeholder="省市区县、乡镇等"
              readonly
            >
              <template v-slot:right>
                <span class="icon-box" @click.stop="goLocation">
                  <v-icon class="icon-location" name="icon-location"></v-icon>
                  <span class="text">定位</span>
              </span>
              </template>
            </nx-input-item>
          </div>
          <div class="item detail">
            <nx-input-item
              class="value"
              title="详细地址"
              :maxRows="1"
              multiline
              :maxlength="50"
              placeholder="街道、楼牌号"
              v-model="addressInfo.detailAddress"
            ></nx-input-item>
          </div>
          <div class="item clipboard">
            <nx-input-item
              class="value"
              type="text"
              multiline
              :placeholder="
                isPickUp
                  ? '粘贴姓名、手机号，可快速识别您的地址'
                  : '粘贴收件人姓名、手机号、地址，可快速识别您的收货信息'
              "
              :maxRows="999"
              v-model="clipboardText"
              @focus="clipboardBtnShow = true"
              @blur="clipBlur"
              @touchend="clipTouchEnd"
            ></nx-input-item>
            <!-- 粘贴板有值且输入框聚焦 -->
            <div ref="clipboardActionRef" class="clipboard-actions" v-show="clipboardText && clipboardBtnShow">
              <span class="clear fs-36 c-aa" @click="clipboardText = ''">清空</span>
              <span class="identify fs-36" @click="clipboardIdentify">识别</span>
            </div>
          </div>
          <div class="checkbox">
            <v-checkbox :value="addressInfo.isDefault" @click="addressInfo.isDefault = !addressInfo.isDefault">
              <span class="fs-45 select-label">设为默认地址</span>
            </v-checkbox>
          </div>
        </div>
      </div>
    </v-os-popup>
    <v-os-popup
      class="address-new-popup popups-no-pb"
      :class="{ 'custom-dark': customDark }"
      v-model="locationShow"
      title="定位地址"
      :closeShow="true"
      :footerShow="false"
      :maxHeightFill="true"
      @close="locationShow = false"
    >
      <AddressLocation v-show="locationShow" :isShow="locationShow" @change="changeLocation" />
    </v-os-popup>
    <nx-vmic-address-picker
      v-backFn="{ show: showRegionSelect, closeFn: 'adressClose' }"
      style="z-index: 3000"
      v-model="showRegionSelect"
      :hotCity="hotCity"
      :addressData="addressData"
      highlightColor="#F10313"
      :province="currentAdress.province"
      :city="currentAdress.city"
      :district="currentAdress.area"
      :isWebviewFull="true"
      @confirm="selectConfirm"
      @hide="adressClose"
    ></nx-vmic-address-picker>
  </div>
</template>
<script>
import { VmicAddressPicker, InputItem, Toast } from '@vivo/vos-ui'
import env from 'utils/clientEnv'
import app from 'utils/app'
import { cleanAddress } from 'utils/common'
import API from 'api'
import { getPopularCity, getaAddressData, saveAddressReq, deleteAddressByIdReq } from '../api'
import { isPhone } from 'utils/reg'
import AddressLocation from 'components/address-location'
import AddressSelect from '../address-select'
import AddressParse from 'address-parse'
import create from '../../create'

export default create({
  name: 'address-new',
  components: {
    AddressLocation,
    AddressSelect,
    [VmicAddressPicker.name]: VmicAddressPicker,
    [InputItem.name]: InputItem
  },

  props: {
    addresses: {
      type: Array,
      default: []
    },
    addressId: {
      type: Number,
      default: 0
    },
    customDark: {
      type: Boolean,
      default: false
    },
    isPickUp: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: ''
    },
    disabledEdit:{
      type: Boolean,
      default: false
    },
    disabledDel:{
      type: Boolean,
      default: false
    },
    trackData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      isSubmiting: false,
      isEdit: false,
      isVivoApp: env.isVivoApp && !env.isVivoPad,
      addressInfo: {
        receiverName: '',
        mobilePhone: '',
        province: '',
        city: '',
        area: '',
        detailAddress: '',
        isDefault: false
      },
      clipboardText: '',
      locationAddress: null,
      showRegionSelect: false,
      clipboardBtnShow: false, // 粘贴板按钮是否展示
      selectAddress: '',
      popupsBackShow: false,
      selectShow: false,
      addressShow: false,
      locationShow: false,
      addressData: null,
      hotCity: []
    }
  },
  computed: {
    currentAdress() {
      if (!this.addressInfo.area || !this.addressInfo.province || !this.addressInfo.city) {
        return { province: '', city: '', area: '' }
      }
      return { province: this.addressInfo.province, city: this.addressInfo.city, area: this.addressInfo.area }
    },
    area() {
      if (!this.addressInfo.area) return ''
      return this.addressInfo.province + ' ' + this.addressInfo.city + ' ' + this.addressInfo.area
    },

    initAddress() {
      return {
        province: this.addressInfo.province,
        city: this.addressInfo.city,
        area: this.addressInfo.area
      }
    }
  },
  watch: {
    async addressShow(newVal) {
      if (!newVal) {
        if (this.clipboardText) {
          this.clipboardText = ''
        }
        return
      }
      if (this.$refs.clipBoardRef) {
        this.$refs.clipBoardRef.resize()
      }
      this.trackData && API.logAll(this.trackData.newAddressPopupsShow())
      if (!this.addressData) {
        this.addressData = await getaAddressData()
        this.hotCity = await getPopularCity()
      }
    },
    clipboardText(newVal, oldVal) {
      this.$nextTick(() => {
        const targetEl = this.$refs.clipboardActionRef
        if (targetEl) {
          targetEl.scrollIntoView()
        }
      })
    }
  },
  methods: {
    adressClose() {
      this.showRegionSelect = false
    },
    selectConfirm(province, city, area) {
      this.showRegionSelect = false
      const addressSelectData = {
        province,
        city,
        area
      }
      this.changeArea(addressSelectData)
    },
    closeSelector() {
      this.selectShow = false
    },
    close() {
      this.addressShow = false
      this.selectShow = false
      this.isSubmiting = false
      // this.isEdit = false
      // this.addressInfo = {}
    },
    closeEditAdress() {
      this.addressShow = false
      // 编辑已有地址时清空，新建和编辑公共一个弹层，避免新建时还保留编辑的已有地址信息
      if (this.addressInfo?.id) {
        this.addressInfo = {
          receiverName: '',
          mobilePhone: '',
          province: '',
          city: '',
          area: '',
          detailAddress: '',
          isDefault: false
        }
      }
    },
    showSelector() {
      this.selectShow = true
      this.trackData && API.logAll(this.trackData.selectAddressPopupsShow())
    },
    show(initAddress) {
      this.isEdit = !!initAddress?.id
      this.addressInfo = Object.assign({}, this.addressInfo, initAddress || {})
      this.addressShow = true
    },
    //
    async goSelector() {
      if (!this.addressData) {
        this.addressData = await getaAddressData()
        this.hotCity = await getPopularCity()
      }
      if (!this.showRegionSelect) {
        this.showRegionSelect = true
      }
    },
    goLocation() {
      this.locationShow = true
      this.trackData && API.logAll(
        this.trackData.newAddressPopupsClick({
          click_Pos: 2
        })
      )
    },
    // 从手机联系人中选择
    selectContact() {
      app.pickContact((name, phone) => {
        this.addressInfo.receiverName = name
        this.addressInfo.mobilePhone = phone
      })

      this.trackData && API.logAll(
        this.trackData.newAddressPopupsClick({
          click_Pos: 1
        })
      )
    },
    // 更新地区
    changeArea(addressSelectData) {
      this.addressInfo = Object.assign({}, this.addressInfo, addressSelectData)
    },
    // 更改定位
    async changeLocation(location) {
      this.addressInfo = Object.assign({}, this.addressInfo, location)
      this.locationShow = false
    },
    // 更改收货信息
    change(address) {
      this.trackData && API.logAll(
        this.trackData.selectAddressPopupsClick({
          button: '选择地址'
        })
      )
      this.$emit('change', { address, isEdit: 1, refresh: false })
      this.close()
    },
    clipBlur() {
      // 避免识别/清空按钮无法触发
      setTimeout(() => {
        this.clipboardBtnShow = false
      }, 1)
    },
    clipTouchEnd() {
      // 解决键盘收起 - 弹起过程中遮挡按钮
      setTimeout(() => {
        const targetEl = this.$refs.clipboardActionRef
        if (targetEl) {
          targetEl.scrollIntoView()
        }
      }, 150)
    },
    // 粘贴板识别
    clipboardIdentify() {
      const cleanText = cleanAddress(this.clipboardText)
      // The parseResult is an object contain { province: '', name: '', city: '', area: '', detail: '', phone: '', postalCode: '' }
      const parseResult = AddressParse.parse(cleanText)
      if (!parseResult || !parseResult[0]) {
        this.$toast('抱歉，没有识别成功哦')
        return
      }
      let { province, city, area, name, mobile: phone, details: detail } = parseResult[0]
      detail = detail.replace(/\s+/gi, ' ')
      // fix 地区/姓名识别异常场景 - 江苏南京市雨花台区南京软件谷 安德门大街25号vivo大厦
      if (detail && name && !phone && name.length > 9 && name.length > detail.length) {
        // 京东-新疆姓名超长的情况
        const checkText = this.clipboardText.replace(new RegExp('(：|:|；|，|,|。|、)', 'g'), ' ')
        if (!checkText.match(new RegExp('(姓名|发件人|收货人|收件人|联系人)(\\s)*' + name, 'ig'))) {
          detail = detail + ' ' + name
          name = ''
        }
      }
      // if (area && name && !phone) {
      //   const spaceList = this.clipboardText.split(' ')
      //   if (spaceList.length > 1) {
      //     const areaName = spaceList.find(item => new RegExp(area + name, 'i').exec(item))
      //     if (areaName) {
      //       detail = name + detail
      //       name = ''
      //     }
      //   }
      // }
      if ((province && city && area) || (name && phone)) {
        this.$toast('识别成功')
        this.addressInfo = Object.assign({}, this.addressInfo, {
          receiverName: name,
          mobilePhone: phone,
          province: province,
          city: city,
          area: area,
          detailAddress: detail
        })
      } else {
        this.$toast('抱歉，没有识别成功哦')
      }
      this.trackData && API.logAll(
        this.trackData.newAddressPopupsClick({
          click_Pos: 3
        })
      )
    },
    // 保存地址
    async saveAddressData() {
      this.trackData && API.logAll(
        this.trackData.newAddressPopupsClick({
          click_Pos: 4
        })
      )
      if (!this.addressInfo.receiverName?.trim()) {
        return this.$toast(this.isPickUp ? '请填写姓名！' : '请填写收件人姓名！')
      }

      if (this.addressInfo.receiverName.trim().length > 20) {
        return this.$toast(this.isPickUp ? '姓名不能超过20个字符' : '收件人姓名不能超过20个字符')
      }

      if (!this.addressInfo.mobilePhone) {
        return this.$toast('请输入手机号码！')
      }
      if (!isPhone(this.addressInfo.mobilePhone)) {
        return this.$toast('请正确填写手机号码！')
      }

      if (!this.area.trim()) {
        return this.$toast('请选择地区！')
      }

      if (!this.addressInfo.province.trim()) {
        return this.$toast('请选择地区！')
      }

      if (!this.addressInfo.city.trim()) {
        return this.$toast('请选择地区！')
      }

      if (!this.addressInfo.area.trim()) {
        return this.$toast('请选择地区！')
      }

      if (!this.addressInfo.detailAddress.trim()) {
        return this.$toast('请输入详细地址！')
      }

      if (this.addressInfo.detailAddress.trim().length > 50) {
        return this.$toast('详细地址不能超过50个字符')
      }

      try {
        if (this.isSubmiting) return
        this.isSubmiting = true
        const addressId = await saveAddressReq(this.addressInfo)
        const address = {
          ...this.addressInfo,
          id: addressId
        }
        this.$emit('change', { address, isEdit: 1, refresh: true })
        this.isSubmiting = false
        Toast.hide()
      } catch (e) {
        if (e && e.msg) {
          this.$toast(e.msg)
          this.isSubmiting = false
        }
      }
      this.close()
    },
    //
    goToNewAddress(address = {}) {
      if (address.id) {
        this.isEdit = true
        this.addressInfo = Object.assign({}, address)
      } else {
        this.isEdit = false
        this.trackData && API.logAll(
          this.trackData.selectAddressPopupsClick({
            button: '新建地址'
          })
        )
      }

      this.addressShow = true
    },
    async clear(id) {
      try {
        await deleteAddressByIdReq(id)
        this.$toast('删除成功')
        this.$emit('clear', id)
      } catch(e) {
        this.$toast(e.msg)
      }
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .address-form-body {
    padding-left: 50px;
  }
  .label {
    line-height: 52px;
    width: 243px;
  }
  .item input,
  .item textarea {
    width: 659px;
  }
  .item .linkman {
    padding-right: 20px;
  }
}
</style>
